module.exports = __webpack_public_path__ + "static/media/Camacol.5d7e1764.png";